import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';

const routes: Routes = [
  { 
    path: '',
    component: AppComponent,
    children: [
      { path: '', loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule)},
      { path: '**', redirectTo: '', pathMatch:'full'}
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
